import { render } from "./shopMemosEditor.vue?vue&type=template&id=cb237080"
import script from "./shopMemosEditor.vue?vue&type=script&lang=js"
export * from "./shopMemosEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__